import React from 'react';

import {
  Container,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import classNames from 'classnames';
import Button from '@uncinc/uncinc-react-kitchen-sink/dist/components/Button';
import { WysiwygField } from '../../../components';
import Card from '../../../components/Molecules/Card';
import { getContentSubType } from '../../../helpers';

import './style.scss';
import { SCREEN_NORMAL } from '../../../config/constants';

const ParagraphLinkThrough = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const subTitle = entity.getIn(['field_subtitle', 0, 'value']);
  const url = entity.getIn(['field_link', 0, 'alias']) || entity.getIn(['field_link', 0, 'uri']);
  const urlText = entity.getIn(['field_link', 0, 'title']);
  const body = entity.getIn(['field_plain_body', 0, 'value'], entity.getIn(['field_text', 0, 'processed']));
  const nodeItems = entity.getIn(['field_linkthrough_content_ref'], []);
  const taxonomyItems = entity.getIn(['field_linkthrough_taxonomy_ref'], []);
  const flipped = entity.getIn(['field_flipped', 0, 'value']);
  const imageClasses = flipped ? classNames('ParagraphLinkThrough__image flipped') : 'ParagraphLinkThrough__image';

  const items = nodeItems.concat(taxonomyItems);
  return (
    <Container className="Paragraph ParagraphLinkThrough">
      <div className="row">
        <div className="col-12">
          <div className="row ParagraphLinkThrough__inner">
            <div className="col-12">
              <div className="ParagraphLinkThrough__wrapper">
                {entity.getIn(['field_media_image', 0]) && (
                  <div className={imageClasses}>
                    <Image
                      src={{
                        [SCREEN_NORMAL]: entity.getIn(['field_media_image', 0, 'styles', 'dossier_card']),
                      }}
                      alt={entity.getIn(['field_media_image', 0, 'alt'], '')}
                    />
                  </div>
                )}
                <div className="ParagraphLinkThrough__content">
                  {subTitle && <div className="ParagraphLinkThrough__subtitle">{subTitle}</div>}
                  <h2 className="ParagraphLinkThrough__title asH3">{title}</h2>
                  {body && (
                    <WysiwygField
                      property="schema:text"
                      className="ParagraphLinkThrough__body subheading2"
                      html={body}
                    />
                  )}
                  {url && <Button className="" href={url}>{urlText}<span className="icon icon-arrow-right icon-variant-2" /> </Button>}
                </div>
              </div>
            </div>
            {items.size > 0
              && (
                <div className="col-12">
                  <div className="ParagraphLinkThrough__items">
                    {items.map((item, index) => {
                      const cardUrl = item.get('url');
                      const type = item.getIn(['entity', 'type', 0, 'target_id']) || item.getIn(['entity', 'vid', 0, 'target_id']);
                      const cardTitle = item.getIn(['entity', 'title', 0, 'value']) || item.getIn(['entity', 'name', 0, 'value']);
                      const uuid = item.getIn(['entity', 'uuid', 0, 'value']);
                      const image = entity.getIn(['entity', 'field_media_image', 0, 'styles', '1_1'], null);
                      const imageAlt = entity.getIn(['entity', 'field_media_image', 0, 'alt'], '');
                      const subType = item.getIn(['entity', getContentSubType(item.getIn(['entity', 'type', 0, 'target_id'])), 0, 'entity', 'name', 0, 'value'], item.getIn(['entity', 'type', 0, 'target_id'])) || type;

                      return (
                        <div key={uuid} className="ParagraphLinkThrough__items__item">
                          <Card small title={cardTitle} image={image} alt={imageAlt} type={type} link={cardUrl} subType={subType} />
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphLinkThrough;
